<template>
  <div>
    <Layout :pagetitle="$t('General Report')">
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col class="m-2">
              <b-row>
                <b-col md="3" v-if="!$route.params.partnerToken">
                  <label>{{ $t('Brand') }}</label>
                  <brandSelectorUnique :modelValue="idBrand" @onChange="changeBrandFilter" />
                </b-col>
                <b-col md="3" v-if="!$route.params.partnerToken">
                  <label>{{ $t('Sub Brand') }}</label>
                  <subBrandsSelector
                    :mode="'single'"
                    :modelValue="idSubBrand"
                    @onChange="setSubBrand"
                    :allowEmpty="true"
                  />
                </b-col>
                <b-col md="3">
                  <label>{{ $t('Data início') }}</label>
                  <input class="form-control" type="date" v-model="startDate" />
                </b-col>
                <b-col md="3">
                  <label>{{ $t('Data fim') }}</label>
                  <input class="form-control" type="date" v-model="endDate" />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12" class="d-flex justify-content-end mt-2">
                  <div>
                    <button class="btn btn-success" :disabled="!idBrand || !month" @click="exportXls">XLS</button>
                    <button class="ml-1 btn btn-primary" :disabled="!idBrand || !month" @click="loadReport">
                      {{ $t('Buscar') }}
                    </button>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <b-card class="m-2" v-if="!$store.state.isLoading">
          <b-row>
            <b-col md="8">
              <h5>{{ $t('Relatório Geral - Comissionados por Nível') }}</h5>
            </b-col>
            <b-col md="4" align="end">
              <div class="btn-group justify-content-end">
                <button
                  v-b-tooltip.hover
                  :title="$t('Visualização Estrutural')"
                  @click="viewMode = 'cards'"
                  :class="`btn btn-sm btn-${isCards}`"
                  size="sm"
                >
                  <i class="fa fa-fw fa-tv"></i>
                </button>
                <button
                  v-b-tooltip.hover
                  :title="$t('Visualização em Lista')"
                  @click="viewMode = 'list'"
                  :class="`btn btn-sm btn-${isList}`"
                  size="sm"
                >
                  <i class="fa fa-fw fa-bars"></i>
                </button>
              </div>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <div class="m-2" v-if="viewMode == 'list'">
                <ReportListView :dataset="report" />
              </div>
              <div class="m-2" v-else>
                <ReportCardsView
                  :n2Filter="n2Filter"
                  :n3Filter="n3Filter"
                  :dataset="report"
                  @showAffiliates="showAffiliates"
                  @setSelectedN2="setSelectedN2"
                  @setSelectedN3="setSelectedN3"
                />
              </div>
            </b-col>
          </b-row>
        </b-card>
        <Skeleton v-else />
      </b-card>
    </Layout>
  </div>
</template>

<script>
import moment from 'moment';
import Layout from '@/views/layouts/main';
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';
import ReportListView from './ReportListView';
import ReportCardsView from './ReportCardsView';
import { jsonToXlsx } from '@/utils/xlsExport/jsonToXlsx';
import staticData from './staticData';
import Skeleton from '@/components/bootstrap/skeleton';
import subBrandsSelector from '@/components/selectors/subBrandsSelector';

export default {
  components: { Layout, brandSelectorUnique, ReportListView, ReportCardsView, Skeleton, subBrandsSelector },
  data() {
    return {
      viewMode: 'cards',
      report: [],
      startDate: moment(moment().format('YYYY-MM')).subtract('months', 1).format('YYYY-MM-DD'),
      endDate: moment(moment().format('YYYY-MM')).subtract('days', 1).format('YYYY-MM-DD'),
      idBrand: this.$store?.state?.partnerAccess?.id_brand || null,
      month: moment().format('YYYY-MM'),
      n2Filter: null,
      idSubBrand: null
    };
  },
  computed: {
    isCards() {
      return this.viewMode == 'cards' ? 'primary' : 'light';
    },
    isList() {
      return this.viewMode == 'list' ? 'primary' : 'light';
    },
    hideCpa() {
      this.$store.state.companySettings;
      return this.shouldHideCpa();
    },
    columns() {
      this.$store.state.companySettings;
      return staticData().affiliateColumns();
    }
  },
  methods: {
    setSubBrand(id = null) {
      this.idSubBrand = id;
    },
    setSelectedN3(n3) {
      this.n3Filter = this.$utils.getObjectRaw(n3);
    },
    setSelectedN2(n2) {
      this.n2Filter = this.$utils.getObjectRaw(n2);
    },
    showAffiliates(n1Filter) {
      if (n1Filter?.id) {
        this.report.affiliateEntries = this.report.affiliateEntries.filter((a) => {
          return parseInt(a.pl1_id) == parseInt(n1Filter.id);
        });
        this.sumAffiliateEntries();
      }
      this.viewMode = 'list';
    },
    loadReport() {
      // if (!this.month) return;
      if (!this.idBrand) return;

      if (!this.startDate || !this.endDate) return;

      let url = 'api/financial/report/general';
      let data = {
        idBrand: this.idBrand,
        startDate: this.startDate,
        endDate: this.endDate
      };

      if (this.idSubBrand) {
        data['idSubBrand'] = this.idSubBrand;
      }

      if (this.$store?.state?.partnerAccess?.id) {
        url = 'affiliate/financial/report/partner';
        data['partner'] = this.$store?.state?.partnerAccess?.id;
      }

      this.$store.commit('SET_LOADING', true);
      this.$api
        .get(url, data)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.report = res.data;

          if (!this?.report?.affiliateEntries?.length) return;

          this.sumAffiliateEntries();
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    sumAffiliateEntries() {
      let summary = {
        a_name: '',
        sub_brand_name: '',
        pl1_name: '',
        pl2_name: '',
        pl3_name: '',
        admin_fee: 0,
        bonus: 0,
        ggr: 0,
        ngr: 0,
        payout: 0,
        reward_accumulative: 0,
        turnover: 0
      };

      if (!this.hideCpa) {
        summary.reward_mark = 0;
        summary.reward_mark_count = 0;
      }

      for (const affiliate of this.report.affiliateEntries) {
        summary.admin_fee += this.$utils.formatFloat(affiliate?.admin_fee || 0);
        summary.bonus += this.$utils.formatFloat(affiliate?.bonus || 0);
        summary.ggr += this.$utils.formatFloat(affiliate?.ggr || 0);
        summary.ngr += this.$utils.formatFloat(affiliate?.ngr || 0);
        summary.payout += this.$utils.formatFloat(affiliate?.payout || 0);
        summary.reward_accumulative += this.$utils.formatFloat(affiliate?.reward_accumulative || 0);
        summary.turnover += this.$utils.formatFloat(affiliate?.turnover || 0);

        if (!this.hideCpa) {
          summary.reward_mark += this.$utils.formatFloat(affiliate?.reward_mark || 0);
          summary.reward_mark_count += this.$utils.formatFloat(affiliate?.reward_mark_count || 0);
        }
      }
      this.report.affiliateEntries.push(summary);
    },
    changeBrandFilter(idBrand) {
      this.idBrand = idBrand;
    },
    exportXls() {
      let dataset = [];
      if (!this?.report?.affiliateEntries?.length) return;

      this.report.affiliateEntries.forEach((a) => {
        let item = a;

        dataset.push(
          this.$utils.pickOrderObj(
            item,
            this.columns.map((c) => c.key)
          )
        );
      });

      dataset = dataset.map((d) => {
        let item = {
          ...d,
          payout: this.$utils.formatFloat(d?.payout),
          turnover: this.$utils.formatFloat(d?.turnover),
          reward_accumulative: this.$utils.formatFloat(d?.reward_accumulative),
          ggr: this.$utils.formatFloat(d?.ggr),
          ngr: this.$utils.formatFloat(d?.ngr),
          admin_fee: this.$utils.formatFloat(d?.admin_fee)
        };

        if (!this.hideCpa) {
          item.reward_mark = this.$utils.formatFloat(d?.reward_mark);
          item.reward_mark_count = this.$utils.formatFloat(d?.reward_mark_count);
        }

        return item;
      });

      jsonToXlsx({
        name: `${this.$t('General Report')} - ${moment().format('DD-MM-YYYY HH:mm')}`,
        headers: this.columns.map((c) => c.label),
        data: dataset
      });
    },
    exportPdf() {}
  },
  watch: {
    viewMode(mode) {
      if (this.report?.affiliateEntries?.length && mode == 'cards') {
        this.loadReport();
      }
    }
  }
};
</script>

<style lang="scss"></style>
